"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC1155 = void 0;
var ERC1155Abi_json_1 = __importDefault(require("./ERC1155Abi.json"));
exports.ERC1155 = ERC1155Abi_json_1.default;
